import {TeamGrid, TeamServiceResponse} from '.';
import {Team} from '../team';
import {TeamSelector} from '../selector';
import {TeamMember} from '../member';

interface FullTeamServiceResponse extends TeamServiceResponse {
	teams: {[index: number]: string};
}

export class FullTeamGrid extends TeamGrid {
	public readonly defaultTeam: string = 'Partners';
	public readonly topTeams: string[] = [
		'Board',
		'Partners',
		'Leadership'
	];

	public teams!: Team[];
	public readonly selector: TeamSelector = new TeamSelector(this);
	private _selected!: Team;

	public async load(): Promise<void> {
		const response = await fetch('/feeds/team');
		const data: FullTeamServiceResponse = await response.json();

		this.teams = Object.entries(data.teams).map(([id, name]) => {
			return new Team(this, parseInt(id), name);
		});
		this.sortTeams();
		this.teams.push(new Team(this, 0, _t('allEmployees')));
		this.members = data.members.map((member) => new TeamMember(this, member));
		for (const team of this.teams) team.sort();
		this.selector.load();

		window.addEventListener('hashchange', () => this.checkHash());
		this.checkHash();
	}

	private sortTeams(): void {
		this.teams.sort((a, b) => a.name.localeCompare(b.name)).sort((a, b) => {
			const aPos = this.topTeams.indexOf(a.name);
			const bPos = this.topTeams.indexOf(b.name);
			return (aPos < 0 ? 100 : aPos) - (bPos < 0 ? 100 : bPos);
		});
	}

	private checkHash(): void {
		const hash = window.location.hash.replace(/^#/, '');
		const selected = this.getTeam('hash', hash || '/');
		if (selected) {
			this.selected = selected as Team;
		} else {
			this.selected = this.getTeam('hash', '/') || this.teams[0];
			if (hash !== '/' && hash !== '') window.history.replaceState({}, '', '#/');
		}
	}

	public getTeam<T extends keyof Team>(by: T, value: Team[T]): Team | undefined {
		return this.teams.find((team) => team[by] === value);
	}

	public set selected(team: Team) {
		this._selected = team;
		this.elements.heading.innerText = team.name;
		this.elements.grid.innerHTML = '';
		for (const team of this.teams) team.checkActive();
		for (const member of team.members) member.render();
	}

	public get selected(): Team {
		return this._selected;
	}
}
